import React from 'react';

import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Loader from 'components/Loader';
import Section from 'components/Section';
import general_messages from 'messages/general_messages';

import ContentArticleTile from '../ContentArticleTile/ContentArticleTile';
import ContentGuideTile from '../ContentGuideTile/ContentGuideTile';
import SelfTestTile from '../SelfTestTile/SelfTestTile';

import useStyles from './RelatedContentOneColumn.styles';

const RelatedContentOneColumn = ({ isLoading, guides, articles, selfTests }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  if (isLoading) return <Loader />;
  return (
    <div className={styles.wrapper}>
      <Typography component='h2' variant='h2'>
        {t(...general_messages.related_content)}
      </Typography>
      {selfTests?.length ? (
        <Section paddingTop={3} smallPadding title={t(...general_messages.content_types.self_test)} titleVariant='h3'>
          <div className={styles.contentWrapper}>
            {selfTests.map(item => (
              <SelfTestTile key={item.id} data={item} id={item.id} />
            ))}
          </div>
        </Section>
      ) : null}
      {articles?.length ? (
        <Section paddingTop={3} smallPadding title={t(...general_messages.content_types.article)} titleVariant='h3'>
          <div className={styles.contentWrapper}>
            {articles.map(data => (
              <ContentArticleTile key={data.id} data={data} withImage />
            ))}
          </div>
        </Section>
      ) : null}
      {guides?.length ? (
        <Section paddingTop={3} smallPadding title={t(...general_messages.content_types.guide)} titleVariant='h3'>
          <div className={styles.contentWrapper}>
            {guides.map(data => (
              <ContentGuideTile key={data.id} darker data={data} id={data.id} />
            ))}
          </div>
        </Section>
      ) : null}
    </div>
  );
};

RelatedContentOneColumn.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  guides: PropTypes.arrayOf(PropTypes.shape({})),
  articles: PropTypes.arrayOf(PropTypes.shape({})),
};

RelatedContentOneColumn.defaultProps = {
  guides: [],
  articles: [],
};

export default RelatedContentOneColumn;
